import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiFirebase,
  SiAnaconda,
  SiWordpress
} from "react-icons/si";

function OtherTechnologies() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiAnaconda />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiWordpress />
      </Col>
    </Row>
  );
}

export default OtherTechnologies;